import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Button, Grid, Paper } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    AgentRegistration as AGENT_REGISTRTION,
    CheckAgentRegistration as USER_AgentRegistration
} from 'Components/Api/NovityDMTAPI';
import { SenderSearch as DMTSenderSearch } from 'Pages/InnerPages/NovityDMT/SenderSearch';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import CircularProgress from '@material-ui/core/CircularProgress';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
const CustomContainer = HOCLoader(Container);

export const AgentRegistration = () => {
    const location = useLocation();
    const ActiveDMTName = location?.state?.DMTName;
    const history = useHistory();
    const classes = commonStyle();
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAgentRegister, setIsAgentRegister] = useState(false);
    const [formObject, setFormObject] = useState({
        Name: '',
        AadhaarNo: '',
        Pincode: '',
        PAN: ''
    });

    useEffect(() => {
        CheckIFAgentRegistration();
    }, []);

    const CheckIFAgentRegistration = async () => {
        var request = {
            DMTName: ActiveDMTName
        };
        var requestObj = JSON.stringify(request);
        setLoading(true);

        const { isAuthorized, status, data } = await USER_AgentRegistration(
            requestObj
        );
        setLoading(false);

        if (!isAuthorized) LOGOUT();

        if (!status) return;

        var d = JSON.parse(data);

        setIsAgentRegister(d.IsRegister);

        if (data.IsRegister === true) {
            return <DMTSenderSearch ActiveDMTName={ActiveDMTName} />;
        }
    };

    const submithandle = async (values, { resetForm }) => {
        values.DMTName = ActiveDMTName;
        setResponseMessage('');
        var requestObj = JSON.stringify(values);
        setIsError(false);
        setLoading(true);

        var response = await AGENT_REGISTRTION(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setIsError(true);
            if (data.Message === 'Agent Already Registered') {
                var param_2 = {
                    Mobile: '',
                    DMTName: ActiveDMTName
                };
                history.push('/NTDMT_SenderSearch', param_2);
                return;
            }
        }

        setSeverity('success');
        setResponseMessage(data.Message);
        setIsError(true);

        var param_2 = {
            Mobile: '',
            DMTName: ActiveDMTName
        };
        history.push('/NTDMT_SenderSearch', param_2);
    };

    const FormValidationSchema = Yup.object({
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'Name'),
        PAN: Yup.string().required(PLEASE_PROVIDE_VALID + 'PanNo'),
        AadhaarNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'AadhaarNo'),
        Pincode: Yup.string()
            .length(6, 'Must be 6 digit')
            .required(PLEASE_PROVIDE_VALID + 'pincode')
    });
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                {isAgentRegister === false ? (
                                    <Form>
                                        <h2 className={classes.PaperHead_h2}>
                                            Agent Registration
                                        </h2>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                        >
                                            <Paper
                                                className={classes.PaperStyle}
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={3}
                                                        lg={3}
                                                    >
                                                        <MaterialTextField
                                                            label="Full Name"
                                                            name="Name"
                                                            length={100}
                                                            type="text"
                                                            placeholder="Full Name"
                                                        />
                                                    </Grid>

                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={3}
                                                        lg={3}
                                                    >
                                                        <MaterialTextField
                                                            label="PAN"
                                                            name="PAN"
                                                            type="text"
                                                            length={10}
                                                            placeholder="PAN"
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={3}
                                                        lg={3}
                                                    >
                                                        <MaterialNumberField
                                                            label="AadhaarNo"
                                                            name="AadhaarNo"
                                                            type="AadhaarNo"
                                                            length={16}
                                                            placeholder="AadhaarNo"
                                                        />
                                                    </Grid>

                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={3}
                                                        lg={3}
                                                    >
                                                        <MaterialNumberField
                                                            label="Pin code"
                                                            name="Pincode"
                                                            type="text"
                                                            length={6}
                                                            title="Pin code"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    className={
                                                        classes.footerGrid
                                                    }
                                                >
                                                    <Box
                                                        className={
                                                            classes.flexReverse
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                classes.SubmitWrapper
                                                            }
                                                        >
                                                            <Button
                                                                type="submit"
                                                                title="Register"
                                                                className={
                                                                    classes.CustomPrimaryButtonStyle
                                                                }
                                                                disabled={
                                                                    loading
                                                                }
                                                            >
                                                                Register
                                                            </Button>
                                                            {loading && (
                                                                <CircularProgress
                                                                    size={24}
                                                                    className={
                                                                        classes.buttonProgress
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                        <Button
                                                            type="reset"
                                                            title="Reset"
                                                            className={
                                                                classes.CustomDangerButtonStyle
                                                            }
                                                        >
                                                            Reset
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    </Form>
                                ) : null}
                            </Grid>
                        </Grid>
                    );
                }}
            />

            {isAgentRegister ? (
                <DMTSenderSearch ActiveDMTName={ActiveDMTName} />
            ) : null}
        </CustomContainer>
    );
};
